import httpStatusCode from '../../../../api-server/constants/httpStatusCode';
import { API_CALL_STATUS } from '../../../reducers/status';
import axios from 'axios';
import { setAhocReferenceDataValue } from '../../../actions/allsureHomeClaim/referenceData';
import { getBasicDetailsForm } from '../../../selectors/allsureHomeClaim/basicDetails';
import { getClaimName } from '../../../selectors/allsureHomeClaim/routing';
import { getClaimDetailsSummary } from '../../../selectors/allsureHomeClaim/confirmation';
import { getSubmittedAndRequiredDocs } from '../../../selectors/allsureHomeClaim/uploadDocuments';
import { navigateToSuccessPage } from '../../../actions/allsureHomeClaim/routing';

export const sendClaimSubmissionService = (store, next, action) => {
    const state = store.getState();
    (async () => {
        // try {
            store.dispatch(setAhocReferenceDataValue({ type: 'apiStatus', value: API_CALL_STATUS.PENDING }));
            const productLabel = getClaimName(state);
            const claimDetailSummary = getClaimDetailsSummary(state);
            const { requiredDocuments,submittedDocuments} = getSubmittedAndRequiredDocs(state);
            const { fullName, mobileNumber, email, policyNumber } = getBasicDetailsForm(state);
            const personalDetails = {
                fullName: fullName.value,
                policyName: productLabel,
                uploadedDocuments: submittedDocuments,
                referenceNumber:policyNumber.value,
                requiredDocuments,
            };

            const dataEmailObj = [personalDetails, ...claimDetailSummary];

            const bussinessRequestBody = {
                firstName: fullName?.value?.split(' ')[0],
                lastName: fullName?.value?.split(' ')[1],
                contactNumber: mobileNumber?.value,
                subject: `Web: ${productLabel} : ${fullName?.value} - REF: ${policyNumber.value}`,
                userDataFields: dataEmailObj,
                templateType: 'ALLSURE_CLAIM_BUSINESS_EMAIL',
                referenceNumber: policyNumber.value ?? '',
                email: 'ALLSURE_CLAIM_BUSSINESS_MAIL',
            };
            const customerRequestBody = {
                firstName: fullName?.value?.split(' ')[0],
                lastName: fullName?.value?.split(' ')[1],
                contactNumber: mobileNumber?.value,
                subject: `Web: ${productLabel} : ${fullName?.value} - REF: ${policyNumber.value}`,
                userDataFields: dataEmailObj,
                templateType: 'ALLSURE_CLAIM_CUSTOMER_EMAIL',
                referenceNumber: policyNumber.value ?? '',
                email: email.value,
            };
            const quoteData = await sendEmailNotification(bussinessRequestBody);
            if (quoteData && quoteData.status === httpStatusCode.OK) {
                await sendEmailNotification(customerRequestBody);
                store.dispatch(setAhocReferenceDataValue({ type: 'apiStatus', value: API_CALL_STATUS.SUCCESS }));
                store.dispatch(navigateToSuccessPage())
            } else {
                store.dispatch(setAhocReferenceDataValue({ type: 'apiStatus', value: API_CALL_STATUS.FAILURE }));
            }
        // } catch (e) {
        //     store.dispatch(setAhocReferenceDataValue({ type: 'apiStatus', value: API_CALL_STATUS.FAILURE }));
        // }
    })();
    return next(action);
};

export const sendEmailNotification = async (requestBody) => {
    try {
        const response = await axios({
            
            url: 'om-api/submit-notification/submitNotificationEmail',
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            data: requestBody,
        });
        return response;
    } catch (error) {
        return null;
    }
};
